<template>
    <swiper-pagination v-bind="$attrs" class="swiper-pagination--ellipse"><slot /></swiper-pagination>
</template>

<script>
import SwiperPagination from "@/components/publish/styles/swipers/swiper-pagination.vue";

export default {
    props: {},
    components: { SwiperPagination },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.swiper-pagination--ellipse {
    ::v-deep {
        .swiper-pagination {
            &-bullet {
                &-active {
                    width: 30px;
                    border-radius: 9999px;
                }
            }
        }
    }

    &.swiper-pagination {
        &--sm {
            ::v-deep {
                .swiper-pagination {
                    &-bullet {
                        &-active {
                            width: 20px;
                        }
                    }
                }
            }
        }
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    .swiper-pagination--ellipse {
        ::v-deep {
            .swiper-pagination {
                &-bullet {
                    &-active {
                        width: 40px;
                    }
                }
            }
        }

        &.swiper-pagination {
            &--sm {
                ::v-deep {
                    .swiper-pagination {
                        &-bullet {
                            &-active {
                                width: 28px;
                            }
                        }
                    }
                }
            }
        }
    }
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
